import { useEffect, useState } from 'react';

/** Tailwind `md` is 768px; below it the right rail is a manual bottom sheet. */
const PHONE_QUERY = '(max-width: 767px)';

function read(): boolean {
  try {
    return typeof window !== 'undefined' && window.matchMedia(PHONE_QUERY).matches;
  } catch {
    return false;
  }
}

/** True on a phone-width layout (< md). False during SSR and where matchMedia is missing. */
export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(read);
  useEffect(() => {
    let mq: MediaQueryList;
    try {
      mq = window.matchMedia(PHONE_QUERY);
    } catch {
      return;
    }
    const on = () => setPhone(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return phone;
}
